import { addClass, createEl, removeClass } from "./utils";
import BranchInterface from "./interfaces/branch.interface";
import Observer from "./observer";

const categoryMap = {
  1: "sucursales",
  2: "cajeros",
  3: "comercios",
};

export default class BranchesList {
  private _container: Element;
  private _branches: BranchInterface[] = [];
  private _branchSelect?: Observer;
  private _loading: boolean = false;

  /**
   * Create BranchesList instance.
   */
  constructor(container: Element) {
    if (!container) {
      throw new Error("BranchList: No container provided.");
    }
    this._container = container;
  }

  /**
   * Set list with branches.
   */
  set branches(branches: BranchInterface[]) {
    if (branches) {
      this._branches = branches;
      this.resetContainer();
      this.createList();
    }
  }

  /**
   * Get branchSelect property.
   */
  get branchSelect(): Observer {
    if (!this._branchSelect) {
      this._branchSelect = new Observer();
    }
    return this._branchSelect;
  }

  /**
   * Set loading property.
   */
  set loading(loading: boolean) {
    this._loading = loading;
    this._loading
      ? addClass(this._container, "loading")
      : removeClass(this._container, "loading");
  }

  /**
   * Get loading property.
   */
  get loading(): boolean {
    return this._loading;
  }

  /**
   * Create list.
   */
  private createList() {
    if (this._branches.length > 0) {
      const list = createEl("div.list");
      for (let i = 0; i < this._branches.length; i++) {
        list.appendChild(this.createListItem(this._branches[i]));
      }
      this._container.appendChild(list);
    } else {
      addClass(this._container, "error");
      this._container.innerHTML = `
        <div>
          <strong>Lo sentimos no se encontraron sucursales cercanas en el C&oacute;digo Postal ingresado, favor de colocar otro C&oacute;digo Postal.</strong>
        </div>
      `;
    }
  }

  /**
   * Create list item.
   */
  private createListItem(branch: BranchInterface) {
    const { nombre, direccion, tipo } = branch;
    const item: Element = createEl(`div.item.type-${categoryMap[tipo]}`);

    item["branch"] = branch;
    item["category"] = tipo;
    item.innerHTML = `
        <h3>${nombre}</h3>
        <div>${direccion}</div>
    `;
    item.addEventListener("click", (e) => this.onItemClick(e));
    return item;
  }

  /**
   * Handles click event on an item.
   */
  private onItemClick(e: Event) {
    const item: any = e.currentTarget;
    const list = item.parentElement;
    const items = list.children;
    for (let curItem of items) {
      if (item === curItem) {
        addClass(curItem, "active");
      } else {
        removeClass(curItem, "active");
      }
    }
    this.branchSelect.fire(item.branch);
  }

  /**
   * Crear contianer.
   */
  resetContainer() {
    removeClass(this._container, "error");
    this._container.innerHTML = "";
  }
}
